const o = function() {
  if (typeof self !== void 0)
    return self;
  if (typeof window !== void 0)
    return window;
  if (typeof global !== void 0)
    return global;
  throw new Error("unable to locate global object");
};
export {
  o as getGlobal
};
